export const PortfolioMatchContent = {
  pageTitle: "Let's think long-term",
};
